var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPriceTagRegular = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4989 15.0142L15.1981 8.30811C15.7313 7.76807 15.786 7.45361 15.786 6.67432V4.0835C15.786 3.32471 15.6083 3.06494 15.0546 2.51123L13.4891 0.945801C12.9286 0.39209 12.6688 0.214355 11.9169 0.214355H9.31922C8.54675 0.214355 8.2323 0.269043 7.6991 0.809082L0.986208 7.5083C-0.0391825 8.53369 -0.0528544 9.62061 0.993044 10.6528L5.35437 15.0142C6.39343 16.0464 7.47351 16.0396 8.4989 15.0142ZM7.61707 13.9683C7.1659 14.4194 6.69422 14.4263 6.22937 13.9614L2.03894 9.77783C1.5741 9.31299 1.58777 8.83447 2.03211 8.39014L8.6698 1.76611C8.80652 1.62939 8.9364 1.54736 9.15515 1.54736H11.9032C12.1083 1.54736 12.2518 1.62256 12.3886 1.75928L14.2411 3.61182C14.371 3.74854 14.4462 3.88525 14.4462 4.09717V6.84521C14.4462 7.0708 14.3778 7.20068 14.2411 7.3374L7.61707 13.9683ZM11.0624 5.91553C11.6229 5.91553 12.0468 5.48486 12.0468 4.93115C12.0468 4.38428 11.6229 3.94678 11.0624 3.94678C10.5087 3.94678 10.0848 4.38428 10.0848 4.93115C10.0848 5.48486 10.5087 5.91553 11.0624 5.91553Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPriceTagRegular);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PriceTagRegular.f0ca524785d5534ffe86dfc65757c8fc.svg";